"use strict";

var Factory = require('rosie').Factory;

var Chance = require('chance');

var moment = require('moment-business-days');

var ShineProducts = require('../products');

var PrintJob = require('../printing/PrintJob');

var productTypes = require('./productTypes.json');

var chance = new Chance();
var pool = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

function createRandomProduct() {
  var product_category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'invitation_suites';
  var reprints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var products = reprints ? productTypes[product_category].reprint : productTypes[product_category]["default"];
  var productType = products[chance.integer({
    min: 0,
    max: products.length - 1
  })];
  var product = ShineProducts.instance()[productType].make({
    product_id: "-".concat(chance.string({
      length: 20,
      pool: pool
    }))
  });
  product.defaults();
  return product;
}
/*
id
order_id
order_type
printer_name
status
archived
approved_on_date
date_created
print_by_date
products
date_completed
designer
sender_id
lastname
firstname
*/


var printer_names = ['printingPlus', 'pistachioPress', 'foilPrinter'];
var statuses = ['received', 'processed', 'printed', 'cut', 'scored_folded', 'finished', 'delivered'];
var factory = Factory.define('print_job').sequence('id').sequence('order_id').attrs({
  printer_name: function printer_name() {
    return printer_names[chance.integer({
      min: 0,
      max: 2
    })];
  },
  status: function status() {
    return statuses[chance.integer({
      min: 0,
      max: 6
    })];
  },
  date_created: function date_created() {
    return moment();
  },
  print_by_date: function print_by_date() {
    return moment().businessAdd(chance.integer({
      min: 0,
      max: 14
    }), 'days');
  },
  products: function products() {
    return [createRandomProduct()];
  }
}).attr('designs').attr('date_completed', ['status', 'print_by_date'], function (status, print_by_date) {
  if (status.match(/delivered/i)) {
    return print_by_date;
  }

  return null;
}).after(function (obj) {
  var print_job = new PrintJob(obj);
  return print_job;
});
module.exports = factory;